import { getMfaOptions, selectMFA } from './SelectMFA.commands';

import { getAllowedMFATypes } from '/b2b/authentication/state/amplify/Amplify.selectors';
import { isLoading } from '/b2b/authentication/state/Auth.selectors';

export const mapStateToProps = state => {
    return {
        savedMFAOptions: getAllowedMFATypes(state) ?? [],
        isLoading: isLoading(state),
    };
};

export const mapDispatchToProps = { selectMFA, getMfaOptions };
